'use strict'

const INSTRUMENT_RUNNING_STATUS_REQUEST= "INSTRUMENT_RUNNING_STATUS_REQUEST";
const INSTRUMENT_RUNNING_STATUS_SUCCESS= "INSTRUMENT_RUNNING_STATUS_SUCCESS";
const INSTRUMENT_RUNNING_STATUS_FAILURE= "INSTRUMENT_RUNNING_STATUS_FAILURE";
const INSTRUMENT_GRAPH_POINTS_REQUEST= "INSTRUMENT_GRAPH_POINTS_REQUEST";
const INSTRUMENT_GRAPH_POINTS_SUCCESS= "INSTRUMENT_GRAPH_POINTS_SUCCESS";
const INSTRUMENT_GRAPH_POINTS_FAILURE= "INSTRUMENT_GRAPH_POINTS_FAILURE";
const INSTRUMENT_UPTIME_DEVICE_STATE_ADD = 'INSTRUMENT_UPTIME_DEVICE_STATE_ADD';
const INSTRUMENT_UPTIME_DEVICE_STATE_REMOVE = 'INSTRUMENT_UPTIME_DEVICE_STATE_REMOVE';

export {
    INSTRUMENT_RUNNING_STATUS_REQUEST,
	INSTRUMENT_RUNNING_STATUS_SUCCESS,
	INSTRUMENT_RUNNING_STATUS_FAILURE,
	INSTRUMENT_GRAPH_POINTS_REQUEST,
	INSTRUMENT_GRAPH_POINTS_SUCCESS,
	INSTRUMENT_GRAPH_POINTS_FAILURE,
	INSTRUMENT_UPTIME_DEVICE_STATE_ADD,
	INSTRUMENT_UPTIME_DEVICE_STATE_REMOVE
}